<template>
  <div class="answer-container">
    <div class="page-content">
      <div class="question-section">
        <div class="question-header" :class="{[currentCategory.categoryID]: true}">
          <p v-html="currentCategory.categoryName"></p>
          <div class="scrores-box">
            <span class="before">for</span>
            <span class="val" v-html="currentAnswer.scores"></span>
          </div>
        </div>
        <div class="question-holder" :class="{[currentCategory.categoryID]: true}">
          <img class="bg-image" src="@/assets/images/intro-bg.jpg" alt="image description" aria-hidden="true">
          <div class="img-box">
            <img class="cat-image" :src="currentAnswer.answerImg" alt="image description" aria-hidden="true">
          </div>
          <div class="question-wrap" :class="currentAnswer.class">
            <h3 v-if="currentAnswer.question" v-html="currentAnswer.question"></h3>
            <p v-html="currentAnswer.questionText"></p>
          </div>
        </div>
        <div class="btn-holder">
          <AppButton class="btn-next" :class="currentAnswer.isRevealed ? 'active' : ''" :style="currentAnswer.isShowed ? 'visibility: hidden;' : ''" @click.prevent="revealQuestion(currentAnswer)"><span>Reveal answer</span></AppButton>
        </div>
      </div>
      <transition name="fade">
        <div class="answer-section" :class="{[currentCategory.categoryID]: true}"  v-if="currentAnswer.isRevealed">
          <div class="question-header" :class="{[currentCategory.categoryID]: true}">
          <p v-html="currentCategory.categoryName"></p>
          <div class="scrores-box">
            <span class="before">for</span>
            <span class="val" v-html="currentAnswer.scores"></span>
          </div>
        </div>
          <img class="bg-image" src="@/assets/images/intro-bg.jpg" alt="image description" aria-hidden="true">
          <div class="container">
            <p v-if="currentAnswer.answer" v-html="currentAnswer.answer"></p>
            <p class="answer-text"  v-html="currentAnswer.answerDescription"></p>

            <AppButton class="btn-next" :style="revealedQuestions >= answers.length ? 'visibility: hidden;' : ''" @click.prevent="goBack()"><span>Return to the gameboard</span></AppButton>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
  import { mapGetters, mapMutations } from "vuex";
  import AppButton from './elements/Button'
  export default {
    name: "Answer",
    components: {
      AppButton
    },
    computed: {
      ...mapGetters({
        answers: 'getAnswers',
        currentCategory: 'getCurrentCategory',
        currentCategoryImage() {
          return this.$store.state.blocks.find(block => block.categoryID === this.$store.state.currentCategory).categoryImage
        },
        currentAnswer: 'getCurrentAnswer',
        revealedQuestions: 'getRevealedQuestions'
      })
    },
    methods: {
      ...mapMutations({
        goToStep: 'goToStep',
        closeAnswer: 'hideAnswer',
        play: 'play',
        stop: 'stop',
        updateRevealedQuestions: 'updateRevealedQuestions'
      }),

      goBack() {
        document.body.classList.remove('answer-active');
        document.body.classList.remove('quest-active');
        this.closeAnswer();
        this.stop('question_reveal');
        this.stop('answer_reveal');

        setTimeout(() => {
          if (this.currentAnswer.isRevealed) this.currentAnswer.isShowed = true
        }, 500);
      },

      makeRevealed(curAnsw) {
        curAnsw.isRevealed = true
      },

      revealQuestion(curAnsw) {
        this.play('answer_reveal')
        this.makeRevealed(curAnsw)
        this.updateRevealedQuestions()
        document.body.classList.add('quest-active');
        if (this.revealedQuestions >= this.answers.length) {
          setTimeout(() => {
            this.stop('question_reveal')
            this.stop('answer_reveal')
            this.goToStep(4)
          }, 5000)
        }
      }
    },
    mounted() {
      window.dispatchEvent(new Event('resize'));
    }
  }
</script>
